export default __webpack_public_path__ + "static/media/close-icon.2dd1d0ec.svg";